import React from 'react'
import maint from '../Assets/Images/not-found.jpg'

const PageNotFound = () => {
  return (
    <div className='w-screen h-full'>
      <img src={maint} className='-z-10 w-full object-cover h-[calc(100vh-160px)]' />
      <div className='absolute  right-20 top-40 w-96 mx-40 bg-[#f2f2f255] p-4 rounded-md'>
       
      </div>

    </div>
  )
}

export default PageNotFound